<template>
  <div class="landing-layout">
    <child/>
  </div>
</template>

<script>
export default {
  name: 'PcsLandingLayout',

  data: function() {
    return {
      currentPcs: null,
    }
  },

  created: function() {
    this.currentPcs = localStorage.getItem('theme')

    // import pcs specific stylesheet
    let file = document.createElement('link')
    file.rel = 'stylesheet'
    file.href = `${process.env.MIX_BASE_URL}/storage/css/modules/dashboard/${this.currentPcs}.css`
    document.head.appendChild(file)
    
    let pcs = localStorage.getItem('pcs')

    // Load PCS-specific color scheme
    axios.post('/api/pcs/load_color_scheme', {
      params: {
        pcs: pcs,
      },
    }).then(response => {
      let root = document.documentElement
      response.data.forEach(color => {
        let tag = '--' + color.tag
        let rgbTag = tag + '-rgb'
        let textTag = tag + '-bg-text'
        let inverseTextTag = tag + '-inverse-bg-text'
        let hoverTag = tag + '-hover'

        let rgb = this.hexToRgb(color.color);
        let rgbValue = rgb ? `${rgb[0]},${rgb[1]},${rgb[2]}` : null
        let textColors = rgb ? this.pickTextColor(rgb[0], rgb[1], rgb[2]) : null
        let hoverColor = rgb ? `${rgb[0] * 0.85}, ${rgb[1] * 0.85}, ${rgb[2] * 0.85}` : null

        root.style.setProperty(tag, color.color)
        root.style.setProperty(rgbTag, rgbValue)
        root.style.setProperty(textTag, textColors.text)
        root.style.setProperty(inverseTextTag, textColors.inverse)
        root.style.setProperty(hoverTag, hoverColor)
      })
    })
  },
  methods: {
    hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      if (result) {
        let r = parseInt(result[1], 16)
        let g = parseInt(result[2], 16)
        let b = parseInt(result[3], 16)
        return [r, g, b]
      }
      return null
    },
    pickTextColor(r, g, b) {
      if (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186) {
        return {
          text: "#000000",
          inverse: "#ffffff",
        }
      }
      else {
        return {
          text: "#ffffff",
          inverse: "#000000",
        }
      }
    },
  }
}
</script>

<style lang="scss">
.landing-layout {
  height: 100vh;
  width: 100vw;
  font-weight: 100;
  position: relative;
  overflow-y: auto;
  background-color: white;

  .links > a {
    color: #636b6f;
    padding: 0 18px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .1rem;
    text-decoration: none;
    text-transform: uppercase;
  }
}

</style>